module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAABFUlEQVQokZ2TLUsEYRSFnxUHMRnWorLVnyAmwWJ0MQo2o+AvMFtc0GYxCWKyLAiLQTFosGkwLWzwI4jBWYNf4bHcxddBZGdPunPuOc/MO8NU1FVgA3gAPimnDKgBDVTUXQfXvgrqcsAW1K+SkHp064RxGEZVve0D0FFr0dkzhrdYnsc1avMfyEmSa4X3gZonoSd1PkKbf0B2Yjej3iV+jtothI+TOy4l/kriHxQ63SLoNIKL6nbMs+pczFv+fJxmEdQ72nUEJpNAK3mKo8SfDu8yPZrqSyxG/f3OVK/Ui4L3ro5H59FkqMZ8b/96VofUEbWNOhaQmxKQntrRzSpqBnSAqZL/WU85UBsG1oBX4GxA0ASw/g3Bh+qgh1HxBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/mail.png
// module id = 287
// module chunks = 0